import React, { memo, useLayoutEffect, useState } from 'react'
import { CheckIcon } from '../../assets/icons/CheckIcon'
import { EditIcon } from '../../assets/icons/EditIcon'
import Collapse from '../collapse/Collapse'
import IconButton from '../iconButton/IconButton'
import { PlayIcon } from '../../assets/icons/PlayIcon'
import { RefreshIcon } from '../../assets/icons/RefreshIcon'
import { TrashIcon } from '../../assets/icons/TrashIcon'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './EditableVideoItem.scss'

const rootClassName = 'component-editable-video-item'

interface EditableVideoItemProps {
  title: string
  url: string
  disabled?: boolean
  urlProps?: {
    placeholder?: string
    maxLength?: number
    validations?: ((val: any) => { error: boolean; helperText?: string })[]
  }
  titleProps?: {
    placeholder?: string
    maxLength?: number
    validations?: ((val: any) => { error: boolean; helperText?: string })[]
  }
  onRemoveClick: () => Promise<any>
  onEditConfirm: (title: string, url: string) => Promise<any>
}

function EditableVideoItem(props: EditableVideoItemProps) {
  const [title, setTitle] = useState<string>(props.title)
  const [url, setUrl] = useState<string>(props.url)
  const [editable, setEditable] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const [errorTitle, setErrorTitle] = useState<{
    error: boolean
    helperText?: string
  } | null>(null)
  useLayoutEffect(() => {
    const finded = props.titleProps?.validations?.find((func) => {
      return func(title).error === true
    })
    setErrorTitle(
      editable && typeof finded === 'function' ? finded!(title) : null
    )
  }, [title, editable, props.titleProps?.validations])

  const [errorUrl, setErrorUrl] = useState<{
    error: boolean
    helperText?: string
  } | null>(null)
  useLayoutEffect(() => {
    const finded = props.urlProps?.validations?.find((func) => {
      return func(url).error === true
    })
    setErrorUrl(editable && typeof finded === 'function' ? finded!(url) : null)
  }, [url, editable, props.urlProps?.validations])

  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-play-icon`}>
        <PlayIcon />
      </div>
      <div className={`${rootClassName}-content`}>
        <div>
          <input
            title={title}
            className={getMergedClassNames([
              `${rootClassName}-input`,
              errorTitle?.error ? 'error' : '',
              editable ? 'editable' : ''
            ])}
            type='text'
            value={title}
            disabled={loading}
            placeholder={props.titleProps?.placeholder}
            maxLength={props.titleProps?.maxLength}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setTitle(e.target.value)
            }
            readOnly={!editable}
          />
          <Collapse opened={editable}>
            <span className={`${rootClassName}-input-error`}>
              {errorTitle?.helperText}
            </span>
          </Collapse>
        </div>
        <div>
          <input
            className={getMergedClassNames([
              `${rootClassName}-input`,
              errorUrl?.error ? 'error' : '',
              editable ? 'editable' : ''
            ])}
            title={url}
            type='text'
            value={url}
            disabled={loading}
            maxLength={props.urlProps?.maxLength}
            placeholder={props.urlProps?.placeholder}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setUrl(e.target.value)
            }
            readOnly={!editable}
          />
          <Collapse opened={editable}>
            <span className={`${rootClassName}-input-error`}>
              {errorUrl?.helperText}
            </span>
          </Collapse>
        </div>
      </div>
      <div className={`${rootClassName}-actions`}>
        {loading ? (
          <RefreshIcon />
        ) : editable ? (
          <IconButton
            icon={<CheckIcon />}
            disabled={errorUrl?.error || errorTitle?.error}
            // tabIndex={!title || !url || urlIsValid() ? -1 : 0}
            // aria-disabled={!title || !url || urlIsValid() ? true : false}
            onClick={() => {
              setLoading(true)
              props.onEditConfirm(title, url).finally(() => {
                setLoading(false)
                setEditable(false)
              })
            }}
          />
        ) : (
          <div className={`${rootClassName}-actions-inside`}>
            <IconButton icon={<EditIcon />} onClick={() => setEditable(true)} />
            <IconButton
              icon={<TrashIcon />}
              onClick={() => {
                setLoading(true)
                props.onRemoveClick!()?.finally(() => {
                  setLoading(false)
                })
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(EditableVideoItem)
